export default __webpack_public_path__ + "static/media/marker-icon-purple2.f504ab74.png";